import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from 'yup'

const EditIssueModal = ({ isOpen, onClose, data, onSubmit }) => {
  const validationSchema = yup.object().shape({
    number: yup.number().required('ნომერი უნდა დაიწეროს რიცხვებით'),
    doi_url: yup.string(),
  })

  const initialValues = {
    number: data?.number || 1,
    doi_url: data?.doi_url || '',
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>ნომრის რედაქტირება</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form>
            <div className='flex flex-col gap-4 p-3.5'>
              <span>
                <label htmlFor='number' className='text-lg'>
                  ნომერი
                </label>
                <Field
                  className='border rounded py-2'
                  autoComplete='off'
                  type='number'
                  id='inputCreatePost'
                  name='number'
                  placeholder='1'
                />
                <ErrorMessage style={{ color: 'red' }} name='year' component='span' />
              </span>
              <span>
                <label htmlFor='doi_url' className='text-lg'>
                  DOI URL
                </label>
                <Field
                  className='border rounded py-2'
                  autoComplete='off'
                  type='text'
                  id='inputCreatePost'
                  name='doi_url'
                  placeholder='https://doi.org/example'
                />
                <ErrorMessage style={{ color: 'red' }} name='volume' component='span' />
              </span>

              <div className='flex flex-row items-center gap-3 justify-end w-full'>
                <Button variant='primary' type='submit'>
                  შენახვა
                </Button>
                <Button onClick={onClose}>Cancel</Button>
              </div>
            </div>
          </Form>
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default EditIssueModal
